var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"t-icon",class:['t-icon__' + _vm.size + 'px', 't-icon__' + _vm.icon]})])}
var staticRenderFns = []

export { render, staticRenderFns }